import type { ReactNode } from "react";
import { Modal } from "./Modal";

interface ConfirmDialogProps {
  title: string;
  /** What will actually happen, one line per consequence. Deactivating a
   *  client cuts off logins AND the ingestion API but does NOT stop the
   *  pipeline -- an operator should not have to know that from memory. */
  consequences: ReactNode[];
  confirmLabel: string;
  tone?: "danger" | "normal";
  busy?: boolean;
  extra?: ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  title, consequences, confirmLabel, tone = "normal", busy, extra, onConfirm, onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal title={title} onClose={onCancel}>
      <h3>{title}</h3>
      <ul className="consequences">
        {consequences.map((c, i) => <li key={i}>{c}</li>)}
      </ul>
      {extra}
      <div className="modal-actions">
        <button onClick={onCancel} disabled={busy}>Cancel</button>
        <button
          className={tone === "danger" ? "btn-danger" : "btn-primary"}
          onClick={onConfirm}
          disabled={busy}
        >
          {busy ? "Working…" : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
